import React from "react";

import { ReactComponent as AddSectionIcon } from "../../../../../../assets/images/environment/AddSectionFill.svg";

export default function ContentAddItem(props) {
  const { handleCreateSection } = props;
  return (
    <div
      onClick={handleCreateSection}
      className="templateBuilderContentAddItem"
    >
      <AddSectionIcon className="templateBuilderContentAddIcon" aria-hidden />
      Add section
    </div>

  );
}
